import { ActionMenuItem } from '../../commons/components/GrowegyMenu';
import { InvoiceIcon } from '../../assets/icons';

export const billingMenuItem = (isHidden: boolean, onClick: () => void): ActionMenuItem => {
  return {
    type: 'standard',
    text: 'Billing',
    icon: <InvoiceIcon />,
    isHidden,
    onClick: () => onClick(),
  };
};
